import React, { PropTypes, Component } from 'react';
import $ from 'jquery';
import Lightbox from 'react-image-lightbox';
import { pure } from 'recompose';
import MessageItem from './MessageItem';
import cx from 'classnames';

const FETCH_WHEN_SCROLL_TOP = 200;
const READ_WHEN_SCROLL_BOTTOM = 100;

class MessageList extends Component {
  static propTypes = {
    user: PropTypes.object.isRequired,
    isFetching: PropTypes.bool.isRequired,
    isReading: PropTypes.bool.isRequired,
    messages: PropTypes.array.isRequired,
    scrollPosition: PropTypes.number,
    requestFetch: PropTypes.func.isRequired,
    requestRead: PropTypes.func.isRequired,
    changeScrollPosition: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {};

    this._handleScroll = this._handleScroll.bind(this);
    this._showImage = this._showImage.bind(this);
    this._hideImage = this._hideImage.bind(this);
  }

  componentDidMount() {
    const { flow } = this.refs;

    // Scrolling to bottom when mounting
    flow.scrollTop = flow.scrollHeight;

    // Handling scroll events
    flow.addEventListener('scroll', this._handleScroll);
  }

  componentDidUpdate() {
    const { flow } = this.refs;
    const { isReading } = this.props;

    // Scrolling to bottom when receiving new message
    flow.scrollTop = flow.scrollHeight;

    // Checking last message and mark it as read if present
    const last = $(this.refs.messages)
      .find('.message')
      .last()[0];
    if (last && !isReading) {
      this.props.requestRead();
    }
  }

  componentWillUnmount() {
    const { flow } = this.refs;
    if (flow) {
      flow.removeEventListener('scroll', this.handleScroll);
    }
  }

  _handleScroll(evt) {
    if (evt.srcElement) {
      const { scrollTop, scrollHeight, offsetHeight } = evt.srcElement;
      const { isFetching, isReading } = this.props;

      if (scrollTop < FETCH_WHEN_SCROLL_TOP && !isFetching) {
        this.props.requestFetch();
      }

      if (
        scrollHeight - (scrollTop + offsetHeight) < READ_WHEN_SCROLL_BOTTOM &&
        !isReading
      ) {
        this.props.requestRead();
      }
    }
  }

  _showImage(msg) {
    if (msg.attachment) {
      this.setState({
        currentImage: msg.attachment.original,
      });
    }
  }

  _hideImage() {
    this.setState({
      currentImage: null,
    });
  }

  render() {
    const { isFetching, messages } = this.props;
    const { currentImage } = this.state;

    const loaderClass = cx('ui small inline loader centered', {
      active: isFetching,
    });

    return (
      <div className="ui segment scrollContent">
        {currentImage && (
          <Lightbox mainSrc={currentImage} onCloseRequest={this._hideImage} />
        )}
        <div className="scroll">
          <div className="flow" ref="flow">
            <div className="messageScreen" ref="messages">
              <div className={loaderClass} />
              {messages.map(m => (
                <MessageItem
                  key={m.index}
                  message={m}
                  onImageClick={this._showImage}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default pure(MessageList);



// WEBPACK FOOTER //
// ./src/modules/messaging/components/MessageList.js